import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const EmployeeCoursesReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                courses:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.EMPLOYEE_COURSES_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, courses: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_EMPLOYEE_COURSES:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, courses: action.payload};

        case ActionTypes.EMPLOYEE_COURSES_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.RESET_EMPLOYEE_COURSES_ERROR:
            return {...state, errMess: null};

        case ActionTypes.ADD_EMPLOYEE_COURSE:
            const nCourse = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, courses: state.courses.concat(nCourse)};
    
        case ActionTypes.UPDATE_EMPLOYEE_COURSE:
            const uCourse = action.payload;
            const updatedCourses = state.courses.map(e => e.id === uCourse.id ? uCourse : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, courses: updatedCourses};

        case ActionTypes.DELETE_EMPLOYEE_COURSE:
            const dCourse = action.payload;
            const filteredCourses = state.courses.filter(e => e.id != dCourse.id);
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, courses: filteredCourses};

        default:
            return state;
    }
};